/*
 * @Author: elevencong
 * @Date: 2023-09-07 19:32:10
 * @LastEditors: elevencong elevencong@tencent.com
 * @LastEditTime: 2023-09-07 22:31:13
 * @FilePath: /milo-core/src/common/supportDomain.js
 * @Description: 判断页面是否支持document.domain属性变更，用来兼容chrome115版本浏览器将document.domain改为只读属性，导致页面跨域通信问题
 */
var isSupportDomain = function isSupportDomain() {
  try {
    document.domain = 'qq.com';
    if (document.domain === 'qq.com') return true;
    return false;
  } catch (err) {
    return false;
  }
};

export default isSupportDomain;